import QueryClientProvider from 'hb-react/shared/providers/QueryClient';
import { useLaunchDarklyProviderConfig } from 'hb-react/shared/utils/launchDarkly';

const LaunchDarkly = ({ children }) => {
  const { status, providerConfig } = useLaunchDarklyProviderConfig();

  if (status !== 'success') {
    return null;
  }

  if (!providerConfig) {
    return children;
  }

  const { provider: LaunchDarklyProvider, ...otherProps } = providerConfig;

  return (
    <LaunchDarklyProvider {...otherProps}>{children}</LaunchDarklyProvider>
  );
};

const LaunchDarklyWrapper = (props) => (
  <QueryClientProvider>
    <LaunchDarkly {...props} />
  </QueryClientProvider>
);

export default LaunchDarklyWrapper;
